import { put, call, takeEvery } from "redux-saga/effects"
import { Logger } from "@ng-mw/shared-react-components"
import { actions } from "./settingsActions"
import { DriftmeldingApiResponse, SettingsActionTypes } from "./types"
import { getFullLocalUrl } from "@app/helpers/useAppContent"

export function* loadDriftmelding() {
    const url = getFullLocalUrl("/api/app/common/driftmelding")

    console.log("URL: ", url)
    try {
        Logger.debug("loadDriftmelding()", { url })
    } catch {}
    try {
        const response: Response = yield call(fetch, url)

        if (!response.ok) {
            yield put(actions.error(response.statusText))
            return
        }
        const settings: DriftmeldingApiResponse = yield call([response, response.json])
        yield put(actions.success(settings))
    } catch (error: any) {
        yield put(actions.error(error))
        Logger.error("loadDriftmelding()", { error })
    } finally {
        yield put(actions.loaded())
    }
}

export default function* loadDriftmeldingSaga() {
    yield takeEvery(SettingsActionTypes.DriftmeldingLoading, loadDriftmelding)
}
